<template>
  <!-- <div class="login"> -->
  <!-- {{msg}} -->
  <v-layout column wrap justify-start align-start class="mt-4" style="padding-left: 15vw;">
    <div>
      <div style="justify-content: center; width: 100%;">
        <h3 class="mb-2" style="margin-top: 10px !important; font-weight: 600;text-align:left;">&nbsp;เครื่องAED</h3>
        <v-layout wrap>
          <v-card class="border-color" @click="routepage('/information/aed?typeSearch=all&page=1&search=')">
            <img :src="BASE_URL + 'static/icon/heart.svg'" height="60px" class="mt-3">
            <h3 style="font-weight: 600;">ทั้งหมด</h3>
            <p class="mt-3px">รวม {{ data_dashboard.all_aed }} เครื่อง</p>
          </v-card>
          <v-card class="border-color" @click="routepage('/information/aed?typeSearch=redcross&page=1&search=')">
            <img :src="BASE_URL + 'static/iconButton/PinAEDRedcross.png'" height="60px" class="mt-3">
            <h3 style="font-weight: 600;">สภากาชาด</h3>
            <p class="mt-3px">รวม {{ data_dashboard.aed_owner }} เครื่อง</p>
          </v-card>
          <v-card class="border-color" @click="routepage('/information/aed?typeSearch=other&page=1&search=')">
            <img :src="BASE_URL + 'static/iconButton/PinAEDAnother.png'" height="60px" class="mt-3">
            <h3 style="font-weight: 600;">อื่นๆ</h3>
            <p class="mt-3px">รวม {{ data_dashboard.aed_partner }} เครื่อง</p>
          </v-card>
          <v-card class="border-color" @click="routepage('/information/history_use?typeSearch=all&page=1&search=')">
            <img :src="BASE_URL + 'static/iconButton/history.svg'" height="60px" class="mt-3">
            <h3 style="font-weight: 600;">ประวัติใช้งานเครื่อง AED</h3>
            <p class="mt-3px">รวม {{ data_dashboard.history_use_aed }} รายการ</p>
          </v-card>
          <v-card class="border-color" @click="routepage('/information/maintenance_aed?page=1&search=')">
            <img :src="BASE_URL + 'static/icon/redcross.svg'" height="60px" class="mt-3">
            <h3 style="font-weight: 600;">รายละเอียดการซ่อมบำรุงเครื่อง AED</h3>
          </v-card>

        </v-layout>
      </div>

      <h3 class="mb-2" style="margin-top: 20px !important;font-weight: 600; text-align:left;">&nbsp;ผู้ใช้</h3>
      <v-layout wrap>
        <v-card class="border-color" @click="routepage('/information/user?type=user')">
          <img :src="BASE_URL + 'static/icon/mentwo.svg'" height="60px" class="mt-3">
          <h3 style="font-weight: 600;">User</h3>
          <p class="mt-3px">รวม {{ data_dashboard.users }} คน</p>
        </v-card>
        <v-card class="border-color" @click="routepage('/information/user?type=cpr')">
          <img :src="BASE_URL + 'static/iconButton/heroCPR.png'" height="60px" class="mt-3">
          <h3 style="font-weight: 600;">Hero CPR</h3>
          <p class="mt-3px">รวม {{ data_dashboard.hero_cpr }} คน</p>
        </v-card>
        <v-card class="border-color" @click="routepage('/information/user?type=runner')">
          <img :src="BASE_URL + 'static/iconButton/runForHeart.png'" height="60px" class="mt-3">
          <h3 style="font-weight: 600;">Run for AED</h3>
          <p class="mt-3px">รวม {{ data_dashboard.run_for_heart }} คน</p>
        </v-card>
        <!-- </v-flex> -->
      </v-layout>
      <h3 class="mb-2" style="margin-top: 20px !important;font-weight: 600;text-align:left;">&nbsp;ผู้ดูแลระบบ
        &nbsp;&nbsp;
        <span style="font-size: 14px !important;">(
          <v-icon class="iconAdminHeader">fas fa-user-alt</v-icon> Admin &nbsp;&nbsp;
          <v-icon class="iconAdminHeader">fas fa-user-cog</v-icon> Superadmin
          )
        </span>
      </h3>
      <v-layout wrap>
        <v-card class="border-color" @click="routepage('/information/admin?typeSearch=owner')"
          v-if="typeCompany == 'owner'">
          <img :src="BASE_URL + 'static/icon/user.svg'" height="60px" class="mt-3">
          <h3 style="font-weight: 600;">ในเครือสภากาชาด</h3>
          <p class="mt-3px">
            <v-icon class="iconAdmin">fas fa-user-alt</v-icon> {{ data_dashboard.admin_owner }} คน
            <v-icon class="iconAdmin">fas fa-user-cog</v-icon> {{ data_dashboard.superadmin_owner }} คน
          </p>
        </v-card>
        <v-card class="border-color" @click="routepage('/information/admin?typeSearch=partner')" v-else>
          <img :src="BASE_URL + 'static/icon/user.svg'" height="60px" class="mt-3">
          <h3 style="font-weight: 600;">หน่วยงานตนเอง</h3>
          <p class="mt-3px">
            <v-icon class="iconAdmin">fas fa-user-alt</v-icon> {{ data_dashboard.admin_owner }} คน
            <v-icon class="iconAdmin">fas fa-user-cog</v-icon> {{ data_dashboard.superadmin_owner }} คน
          </p>
        </v-card>
        <v-card class="border-color" @click="routepage('/information/admin?typeSearch=partner')"
          v-if="typeCompany == 'owner'">
          <img :src="BASE_URL + 'static/icon/user.svg'" height="60px" class="mt-3">
          <h3 style="font-weight: 600;">ร่วมโครงการ</h3>
          <p class="mt-3px">
            <v-icon class="iconAdmin">fas fa-user-alt</v-icon> {{ data_dashboard.admin_partner }} คน
            <v-icon class="iconAdmin">fas fa-user-cog</v-icon> {{ data_dashboard.superadmin_partner }} คน
          </p>
        </v-card>
        <v-card class="border-color" @click="routepage('/information/admin?typeSearch=maintenance')">
          <img :src="BASE_URL + 'static/icon/building.svg'" height="60px" class="mt-3">
          <h3 style="font-weight: 600;">บำรุงรักษาเครื่อง AED</h3>
          <v-icon class="iconAdmin">fas fa-user-alt</v-icon> {{ data_dashboard.maintenance_owner }} คน
        </v-card>
      </v-layout>
    </div>
  </v-layout>
</template>

<script>
export default {
  data () {
    return {
      msg: 'homepage',
      BASE_URL: process.env.BASE_URL,
      typeCompany: '',
      data_dashboard: {}
    }
  },
  created () {
    this.typeCompany = this.$store.state.key_object.typeCompany
    this.getDataDashboard()
  },
  methods: {
    routepage (path) {
      this.$router.push(path)
    },
    getDataDashboard () {
      this.$api.getDataDashboard().then((response) => {
        this.data_dashboard = response.data.data
      })
    }
  }
}
</script>

<style scoped>

>>>.v-card__actions {
  padding: 0px !important;
}
>>>.v-card__title {
  padding: 0px !important;
}
/*>>>.theme--light.v-divider {
    border-width: thin !important;
    border-color: rgb(168, 14, 0) !important;
}*/
.border-color {
  margin-right: 15px !important;
  height: 145px !important;
  width: 200px !important;
  border-radius: 11px !important;
  background-color: white !important;
  color: #a80e00 !important;
  border-style: solid !important;
  border-width: medium !important;
  border-color: #a80e00 !important;
  cursor: pointer !important;
}
.border-color:hover {
  color: white !important;
  background: #a80e00 !important;
  border-color: #9a0c00 !important;
}
.border-color .iconAdmin {
  font-size: 18px !important;
  color: #a80e00 !important;
}
.border-color:hover .iconAdmin {
  color: white !important;
}
.iconAdminHeader {
  font-size: 18px !important;
  color: #a80e00 !important;
}
h1, h3 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.mt-3px {
      margin-top: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage.vue